<template>
  <div>
    <v-dialog
      v-model="successDialog"
      width="500px"
      persistent
    >
      <v-card>
        <v-card-title
          class="headline green"
          primary-title
        >
          <v-layout row justify-center>
            <v-icon dark x-large>check_circle_outline</v-icon>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <h3>{{ successMsg }}</h3>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="closeSuccessDialog"
          >
            {{ $translate("OK") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "SuccessDialog",
  props: {
    successMsg: String
  },
  data() {
    return {
      successDialog: true
    };
  },
  methods: {
    closeSuccessDialog() {
      this.successDialog = false;
      this.$emit("success-dialog-closed");
    }
  }
}
</script>